/**
*** 人员管理--专家界面
 */
<template>
<div id="ExportPage" class="jc-page">
    <div class="jc-panel jc-page-head">
        <div class="header-title">专家管理</div>
        <div class="header-operation">
            <el-input style="width:200px;" v-model="expert_real_name" placeholder="请输入专家姓名"></el-input>
            <el-select clearable style="" v-model="expert_major_id"  placeholder="请选择专家专业">
                <el-option
                    v-for="item in majors"
                    :key="item.expert_major_id"
                    :label="item.expert_major_name"
                    :value="item.expert_major_id">
                </el-option>
            </el-select>
            <el-button type="primary" @click="loadData">查询</el-button>
            <el-button @click="deleteRows" type="primary">删除</el-button>
            <el-button type="primary" @click="openAddDialog">添加</el-button>
        </div>
    </div>
    <div class="jc-table-container jc-scroll-panel">
        <el-table

            ref="multipleTable"
            :data="expertData"
            tooltip-effect="dark"
            @selection-change="handleSelectionChange"
            style="width: 100%">

                <el-table-column type="selection" width="55"></el-table-column>
                <el-table-column label="序号" prop="No"></el-table-column>
                <el-table-column label="姓名" prop="expert_real_name"></el-table-column>
                <el-table-column label="性别" prop="expert_sex">
                    <template slot-scope="scope">
                        {{scope.row.expert_sex == "1" ? '男':(scope.row.expert_sex == "0" ? '保密':'女')}}
                    </template>
                </el-table-column>
                <el-table-column label="单位名称" prop="expert_unit_name"></el-table-column>
                <el-table-column label="手机号" prop="expert_mobile"></el-table-column>
                <el-table-column label="专业" prop="expert_major_name_string"></el-table-column>
                <el-table-column label="职务/职称" prop="expert_position_name"></el-table-column>
                <el-table-column label="操作" width="100">
                    <template slot-scope="scope">
                        <el-button @click="modifyRow(scope.row)" type="text" size="small">编辑</el-button>
                        <span>|</span>
                        <el-button type="text" size="small" @click="deleteRow(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                style="text-align:right"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-size="count"
                layout="total, prev, pager, next"
                :total="total"
                >
            </el-pagination>
    </div>
    <el-dialog class="jc-dialog" :visible.sync="showAddDialog"
        :title="addDialogTitle" :before-close="cancelAddDialog">
        <div>
            <div style="text-align:left;padding-bottom:20px;border-bottom:1px solid #BBBBBB;">
                <div>手机号查询</div>
                <div style="margin-top:5px;">
                    <el-input placeholder="请输入手机号" size="mini" v-model="phoneNumber" style="width:200px;"></el-input>
                    <el-button @click="queryExpertByPhoneNumber" style="background:#000;color:#fff;border:none;" size="mini">查询</el-button>
                    <el-button @click="phoneNumber = ''" style="background:#000;color:#fff;border:none;" size="mini">重置</el-button>
                    <!--<el-button @click="queryExpertByPhoneNumber" style="background:#000;color:#fff;border:none;" size="mini">查询</el-button>-->
                </div>
            </div>
            <el-form ref="addFormRef" :model="personForm" :rules="addRulers">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="人员姓名" prop="expert_real_name">
                            <el-input :disabled="isFindExpert" v-model="personForm.expert_real_name" placeholder="请输入人员姓名"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="性别" prop="expert_sex">
                            <el-select clearable :disabled="isFindExpert" v-model="personForm.expert_sex" placeholder="请输入性别">
                                <el-option label="保密" value="0"></el-option>
                                <el-option label="男" value="1"></el-option>
                                <el-option label="女" value="2"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="单位名称">
                            <el-input :disabled="isFindExpert" v-model="personForm.expert_unit_name" placeholder="请输入单位名称"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="手机号" prop="expert_mobile">
                            <el-input :disabled="isFindExpert" v-model="personForm.expert_mobile" placeholder="请输入手机号"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="登录名">
                            <el-input :disabled="isFindExpert" v-model="personForm.username" placeholder="请输入登录名"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="密码">
                            <el-input :disabled="isFindExpert" @input="change($event)" show-password v-model="personForm.password" placeholder="请输入密码"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="确认密码" prop="conPassword">
                            <el-input :disabled="isFindExpert" show-password v-model="personForm.conPassword" placeholder="请输入确认密码"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="职务/职称">
                            <el-input :disabled="isFindExpert" v-model="personForm.expert_position_name" placeholder="请输入职务/职称"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="专业">
                            <el-select @change="$forceUpdate()" clearable multiple v-model="personForm.expert_major_id_list" placeholder="请输入专业">
                                <el-option
                                    v-for="item in majors"
                                    :key="item.expert_major_id"
                                    :label="item.expert_major_name"
                                    :value="item.expert_major_id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="人员档案">
                            <br>
                            <el-upload
                                :on-preview="handlePreview"
                                :file-list="filelist"
                                :data="profileUploadParam"
                                :action="UploadProfileUrl()"
                                :on-success="profileUploadSuccess">
                                <div>
                                    <el-button type="primary" size="small" >上传</el-button>
                                </div>
                            </el-upload>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="cancelAddDialog">取消</el-button>
            <el-button type="primary" @click="okAddDialog">确定</el-button>
        </div>
    </el-dialog>
</div>
</template>
<script>
import {getExpertOrganizationDetail, deleteExpertOrganizationInfo, getExpertOrganizationList, getExpertMajorList, getExpertDetail, saveExpertOrganizationInfo} from '@/apis/person'
import {getToken, getUserId, getIdentityType} from '@/utils/auth'
export default {
   name:"Expert",
   data(){
       var validateConPassword = (rule, value, callback) => {
            if(value < this.personForm.password){
                this.$message.error('两次密码不一致');
                callback(new Error());
            } else {
                callback();
            }
        }
       return {
            filelist:[],
            addRulers:{
                conPassword: [
                    { validator: validateConPassword, trigger: 'blur' }
                ],
                expert_real_name: [
                    { required: true, message: '请输入人员姓名', trigger: 'blur' }
                ],
                expert_sex: [
                    { required: true, message: '请输入性别', trigger: 'blur' }
                ],
                expert_mobile: [
                    { required: true, message: '请输入手机号', trigger: 'blur' }
                ],
            },
            expert_real_name:'',
            expert_major_id:'',
            multipleSelection:[],
            currentPage:1,// 当前页数
            count:10,//表格页数
            total:0,// 总条目数
            expertData:[],
            showAddDialog:false,
            phoneNumber:'',
            personForm:{
                expert_organization_id:'0',
                expert_id:'',
                expert_real_name:'',
                expert_sex:'',
                expert_mobile:'',
                expert_unit_name:'',
                expert_position_name:'',
                username:'',
                password:'',
                conPassword:'',
                expert_major_id_list:[],

            },

            majors:[],
            addDialogTitle:'添加专家',
            isFindExpert:true,
            profileUploadParam:{
                device_type:20,
                user_id:getUserId(),
                token:getToken(),
                identity_type:getIdentityType(),
                jsonText:JSON.stringify({"file_type_key":"expert_archives_file"})
            },
            uploadUrl: process.env.BASE_API

       }
   },
   mounted(){
       this.loadData()
       this.loadBasicData()
   },
   methods:{
     handlePreview(file) {
       var a = document.createElement('a');
       var event = new MouseEvent('click');
       a.download = file.name;
       a.href = file.url;
       a.dispatchEvent(event);
       console.log(file)
     },
     change(e){
       this.$forceUpdate();
     },
        profileUploadSuccess(res, file, filelist){
            if(res.data.file_info){
                this.filelist = [
                    {
                        name: res.data.file_info.file_name,
                        path:res.data.file_info.path,
                        url:res.data.file_info.url
                    }
                ]
            }
        },
        UploadProfileUrl: function() {
            return this.uploadUrl + "/Base/Tools/editFile";
        },
        handleSelectionChange(val){
            this.multipleSelection = val
        },
        modifyRow(row){
            this.isFindExpert = false

            getExpertOrganizationDetail({
                "expert_organization_id":row.expert_organization_id,

            }).then(res=>{
                this.personForm = res.data.data.expert_organization_info
                this.personForm.expert_major_id_list = []
                res.data.data.expert_organization_info.expert_major_list.forEach(x=>{
                    this.personForm.expert_major_id_list.push(x.expert_major_id)
                })

                this.personForm.password = ''
                this.showAddDialog = true
                this.addDialogTitle = '修改专家'
                let fileInfo = res.data.data.expert_organization_info.expert_archives_file_info;
               if(fileInfo){
                 fileInfo.name = fileInfo.file_name;
                 this.filelist = [fileInfo];
               }


            })
        },
        deleteRow(row){
            this.$confirm('是否删除数据?').then(() => {
                deleteExpertOrganizationInfo({
                    expert_organization_id_list:[row.expert_organization_id]
                }).then(res=>{
                    this.loadData()
                    this.$message.success("删除成功")
                })
            })
        },
        deleteRows(){
             this.$confirm('是否删除数据?').then(() => {
                if(this.multipleSelection.length > 0){
                    let temp = []
                    this.multipleSelection.forEach(x=>{
                        temp.push(x.expert_organization_id)
                    })
                    deleteExpertOrganizationInfo({
                        expert_organization_id_list:temp
                    }).then(res=>{
                        this.loadData()
                        this.$message.success("删除成功")
                    })
                } else {
                    this.$message.error("请选择待删除数据")
                }
            })
        },
        handleSizeChange(val) {
        },
        handleCurrentChange(val) {
            this.loadData()
        },
        initFormModel(){
            this.personForm = {
                expert_organization_id:'0',
                expert_id:'',
                expert_real_name:'',
                expert_sex:'',
                expert_mobile:'',
                expert_unit_name:'',
                expert_position_name:'',
                username:'',
                password:'',
                conPassword:'',
                expert_major_id_list:[],

            }
        },
        loadBasicData(){
            getExpertMajorList().then(res=>{
                this.majors = res.data.data.expert_major_list
            })
        },
        loadData(){
            getExpertOrganizationList({
                "expert_real_name":this.expert_real_name,
                "expert_major_id":this.expert_major_id,
                "pagination":{
                    "page":this.currentPage,
                    "count":this.count
                }
            }).then(res=>{
                this.expertData = res.data.data.expert_organization_list
                this.total = Number(res.data.data.paginated.total)
            })
        },
        cancelAddDialog(){
            this.showAddDialog = false
            this.initFormModel()
            this.filelist = [];

        },
        openAddDialog(){
            this.isFindExpert = false
             this.showAddDialog = true
             this.phoneNumber = ""
             this.addDialogTitle = '添加专家'
        },
        okAddDialog(){
            this.$refs.addFormRef.validate(valid=>{
                if(valid){
                    let expert_id = ""
                    if(this.addDialogTitle == '添加专家'){
                        expert_id = this.personForm.expert_id
                    } else {
                        expert_id = this.personForm.expert_id
                    }
                    let data = {
                        "expert_organization_id" : this.personForm.expert_organization_id,
                        "expert_id" : expert_id,
                        "expert_real_name" : this.personForm.expert_real_name,
                        "expert_sex" : this.personForm.expert_sex,
                        "expert_mobile" : this.personForm.expert_mobile,
                        "expert_unit_name" : this.personForm.expert_unit_name,
                        "expert_position_name" : this.personForm.expert_position_name,
                        "username" : this.personForm.username,
                        "password" : this.personForm.password,
                        "expert_major_id_list":this.personForm.expert_major_id_list,

                    }
                    if(this.filelist[0]){
                        data.expert_archives_file = this.filelist[0].path
                    }
                    saveExpertOrganizationInfo(data).then(res=>{
                        if(res.data.status == "1"){
                            this.$message.success("添加成功")
                            this.loadData()
                            this.initFormModel()
                            this.showAddDialog = false
                            this.filelist = []
                        } else {
                            this.$message.error(res.data.msg)
                        }
                    })
                }
            })

        },
        queryExpertByPhoneNumber(){
            if(this.phoneNumber.trim().length > 0){
                getExpertDetail({
                    expert_mobile:this.phoneNumber
                }).then(res=>{
                    if(res.data.status == "1"){
                        if(res.data.data.expert_info == ""){
                            this.isFindExpert = false
                        } else {
                            this.isFindExpert = true
                            this.personForm = res.data.data.expert_info
                            this.personForm.expert_organization_id = "0"
                            this.personForm.password = ""
                        }

                    } else {
                        this.isFindExpert = false
                    }
                })
            } else {
                this.$message.error("请输入待查询电话号码")
            }
        },
   }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Orgin/PersonManag/Expert.vue